export default "__VITE_ASSET__xnNJkeXy__"